import { apiFetch } from "./client";

export type NotificationKind =
  | "ORDER_STATUS_CHANGED"
  | "CONTRACT_SENT"
  | "CONTRACT_SIGNED"
  | "CONTRACT_EXPIRY_WARNING"
  | "INVITATION_ACCEPTED"
  | "GENERIC"
  | "CHAT_MENTIONED"
  | "CHAT_REPLIED"
  | "CHAT_DIRECT"
  | "ORDER_DISPATCHED"
  | "DISPATCH_ORDER_RELEASED"
  | "DISPATCH_ORDER_HELD";

export type NotificationView = {
  id: string;
  kind: NotificationKind;
  titleKey: string;
  bodyKey: string | null;
  placeholders: Record<string, unknown>;
  data: Record<string, unknown>;
  href: string | null;
  read: boolean;
  readAt: string | null;
  createdAt: string;
};

/** Where an event belongs on the settings card. */
export type NotificationGroup =
  | "ORDERS" | "DISPATCH" | "CONTRACTS" | "COMPLAINTS" | "OFFERS" | "DELIVERIES" | "TASKS" | "CHAT" | "OTHER";

/** One event the user is told of: each channel on or off, null where the event has no such channel. */
export type NotificationChannelChoice = {
  event: string;
  group: NotificationGroup;
  inApp: boolean | null;
  email: boolean | null;
};

export const notificationChannelsApi = {
  list: () => apiFetch<NotificationChannelChoice[]>("/me/notification-channels"),
  /** Turns one event's channels on or off; a channel left out stays as it is. */
  choose: (event: string, body: { inApp?: boolean; email?: boolean }) =>
    apiFetch<NotificationChannelChoice>(`/me/notification-channels/${event}`, { method: "PUT", body }),
};

export const notificationsApi = {
  list: () => apiFetch<NotificationView[]>("/notifications"),
  unreadCount: () => apiFetch<{ count: number }>("/notifications/unread-count"),
  markRead: (id: string) =>
    apiFetch<void>(`/notifications/${id}/read`, { method: "POST" }),
  markAllRead: () =>
    apiFetch<{ updated: number }>("/notifications/read-all", { method: "POST" }),
};
